(() => {
  let queued = false;

  const important = (element, property, value) => {
    if (element) element.style.setProperty(property, value, 'important');
  };

  const centerCloudPrices = () => {
    document.querySelectorAll([
      '.cloud-search-filters-products .sxt-price-grid',
      '.cloud-search-filters-products .cs-price-block',
      '.template-search #product-grid .sxt-price-grid',
      '.template-search #product-grid .cs-price-block',
      '.sxt-search-page #product-grid .sxt-price-grid',
      '.sxt-search-page #product-grid .cs-price-block',
      '#cloud_search_filters_root .product-grid .sxt-price-grid',
      '#cloud_search_filters_root .product-grid .cs-price-block'
    ].join(',')).forEach((price) => {
      important(price, 'display', 'grid');
      important(price, 'width', '100%');
      important(price, 'max-width', 'none');
      important(price, 'margin-left', 'auto');
      important(price, 'margin-right', 'auto');
      important(price, 'justify-content', 'center');
      important(price, 'justify-items', 'center');
      important(price, 'text-align', 'center');

      const information = price.closest('.card-information, .card-information__wrapper, [class*="product-info"], [class*="product-details"], [class*="product-card"]');
      important(information, 'width', '100%');
      important(information, 'max-width', 'none');
      important(information, 'text-align', 'center');

      price.querySelectorAll('.sxt-price-now, .sxt-price-reference, .price, s').forEach((line) => {
        important(line, 'margin-left', 'auto');
        important(line, 'margin-right', 'auto');
        important(line, 'justify-content', 'center');
        important(line, 'text-align', 'center');
      });
    });
  };

  const simplifySearchPreview = () => {
    document.querySelectorAll('.details-top-text').forEach((preview) => {
      const current = preview.querySelector('.cs-has-list-price') || preview.querySelector('.price:not(.cs-list-price)');
      const market = preview.querySelector('.cs-list-price');
      if (!current) return;

      preview.classList.add('sxt-search-preview-v20');
      preview.querySelectorAll('.sxt-cloud-retail,.sxt-cloud-b2c,.sxt-cloud-final').forEach((extra) => extra.remove());
      if (market) important(market, 'display', 'none');

      important(current, 'display', 'inline-block');
      important(current, 'width', 'auto');
      important(current, 'margin-left', 'auto');
      important(current, 'margin-right', 'auto');
      important(current, 'padding-left', '.14em');
      important(current, 'padding-right', '.14em');
      important(current, 'color', '#171717');
      important(current, 'font-weight', '750');
      important(current, 'text-align', 'center');
      important(current, 'text-decoration', 'none');
      important(current, 'background', 'linear-gradient(transparent 58%, rgba(197,166,45,.48) 58%)');
    });
  };

  const simplifyCloudAutocomplete = () => {
    document.querySelectorAll('#cloud-search-results .cs-price-block').forEach((price) => {
      const current = price.querySelector('.cs-has-list-price')
        || [...price.querySelectorAll('.price')].find((node) => !node.classList.contains('cs-list-price'))
        || price.firstElementChild;
      if (!current) return;

      price.classList.add('sxt-search-autocomplete-v28');
      price.querySelectorAll('.cs-list-price, .compare-at-price, del, s, .sxt-cloud-retail, .sxt-cloud-b2c, .sxt-cloud-final').forEach((extra) => {
        if (extra !== current && !extra.contains(current)) extra.remove();
      });

      important(price, 'display', 'flex');
      important(price, 'align-items', 'center');
      important(price, 'justify-content', 'center');
      important(price, 'width', '100%');
      important(price, 'text-align', 'center');
      important(current, 'display', 'inline-block');
      important(current, 'width', 'auto');
      important(current, 'margin-left', 'auto');
      important(current, 'margin-right', 'auto');
      important(current, 'padding-left', '.14em');
      important(current, 'padding-right', '.14em');
      important(current, 'background', 'linear-gradient(transparent 58%, rgba(197,166,45,.48) 58%)');
      important(current, 'color', '#171717');
      important(current, 'font-weight', '750');
      important(current, 'text-align', 'center');
      important(current, 'text-decoration', 'none');
      current.querySelectorAll('*').forEach((part) => {
        important(part, 'color', '#171717');
        important(part, 'font-weight', '750');
        important(part, 'text-decoration', 'none');
      });
    });
  };

  const enhance = () => {
    queued = false;
    centerCloudPrices();
    simplifySearchPreview();
    simplifyCloudAutocomplete();
  };

  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(enhance);
  };

  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('cloud-search:render', schedule);
  document.addEventListener('DOMContentLoaded', schedule, { once: true });
  schedule();
})();
